import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    strategiesData: [],  
    strategyError: '',  
    strategyTableRow: '',  
    selectedRowIndex: null,
    selectedStrategyPlot: {},
    selectedStrategy:{'symbol' : '', 'interval' : '', 'ema_1':'', 'ema_2' : '', 'strategy' : ''}
};

const simulationStratgySlicer = createSlice({
  name: 'simulationStratgy',
  initialState,
  reducers: {
    setStrategiesData: (state, action) => {
      state.strategiesData = action.payload;
    },
    setStrategyError: (state, action) => {
      state.strategyError = action.payload;
    },
    setStrategyTableRow: (state, action) => {
      state.strategyTableRow = action.payload;
    },
    setSelectedRowIndex: (state, action) => {
      state.selectedRowIndex = action.payload;
    },
    setSelectedStrategyPlot: (state, action) => {
      state.selectedStrategyPlot = action.payload;
    },
    setSelectedStrategy: (state, action) => {
      state.selectedStrategy = action.payload;
    }
  }  
});

export const { setStrategiesData, setStrategyError, setStrategyTableRow, setSelectedRowIndex, setSelectedStrategyPlot, setSelectedStrategy } = simulationStratgySlicer.actions;
export default simulationStratgySlicer.reducer;